import { RateType, RateFeatureType } from 'apps/aiTextImprover/lib/types'
import { AnyAiGeneratorRequestData } from 'shared/api/requests/aiContentGenerator/schemas'
import { analyticsService } from 'utils/services/analytics'

export const AiAnalytics = {
  logReaction: (
    data:
      | {
          feature: RateFeatureType.TEXT_IMPROVER
          reaction: RateType
          text: string
          context: AnyAiGeneratorRequestData
        }
      | {
          feature: RateFeatureType.AI_ASSISTANT
          reaction: RateType
          session_id: string
          flow_ns: string
        },
  ) => analyticsService.sendEvent('AI.REACTION', data),
}
